// icons.js — inline SVG transport glyphs.
//
// Zero runtime deps (CLAUDE.md Rule #5): no icon font, no icon library. Each
// constant is a self-contained SVG string sized to `1em` and painted with
// `currentColor`, so a button's `color` / `font-size` drive the glyph.
//
// `aria-hidden` + `focusable="false"`: the glyph is decorative; the button's
// `aria-label` carries the accessible name.

/** @param {string} body @returns {string} */
const svg = (body) =>
  `<svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false">${body}</svg>`;

/** ▶ play triangle */
export const PLAY = svg(`<path d="M8 5v14l11-7z"/>`);

/** ⏸ pause bars */
export const PAUSE = svg(`<path d="M6 5h4v14H6zM14 5h4v14h-4z"/>`);

/** ■ stop square */
export const STOP = svg(`<rect x="6" y="6" width="12" height="12"/>`);

/** ⏪ rewind (double left chevron) */
export const REWIND = svg(`<path d="M11 6 3 12l8 6V6zM20 6l-8 6 8 6V6z"/>`);

/** 🔒 padlock (closed) — used by the upsell to mark locked items */
export const LOCK = svg(`<path d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 0 1 6 0v3H9z"/>`);

/** ✕ close (used by dismissible overlays) */
export const CLOSE = svg(`<path d="M18.3 5.7 12 12l6.3 6.3-1.4 1.4L10.6 13.4 4.3 19.7 2.9 18.3 9.2 12 2.9 5.7 4.3 4.3l6.3 6.3 6.3-6.3z"/>`);
